






import Vue from "vue";
import Component from "vue-class-component";
import Hero from "@/components/arma/tis/Hero.vue";
import UrlBox from "@/components/arma/tis/UrlBox.vue";

@Component({
  components: { Hero, UrlBox },
  metaInfo: {
    title: "Tyr Intelligence & Security – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Our currently running Arma 3 PMC Roleplay campaign." },
      { vmid: "og:title", property: "og:title",
        content: "Tyr Intelligence & Security – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Our currently running Arma 3 PMC Roleplay campaign." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/tis" },
    ],
  },
})
export default class Tis extends Vue {}
